import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  // Detect mobile viewport
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const navLinks = [
    {
      label: 'Main Dashboard',
      path: '/main-visualization-dashboard',
      icon: 'PieChart'
    },
    {
      label: 'Historical Trends',
      path: '/historical-trend-overlay',
      icon: 'TrendingUp'
    }
  ];

  // Only add Mobile View link on mobile devices
  if (isMobile) {
    navLinks?.push({
      label: 'Mobile View',
      path: '/mobile-responsive-view',
      icon: 'Smartphone'
    });
  }

  const isActivePath = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card shadow-md">
      <div className="flex items-center justify-between h-16 px-6">
        <Link 
          to="/main-visualization-dashboard" 
          className="flex items-center gap-3 transition-opacity duration-300 hover:opacity-80"
        >
          <div className="flex items-center justify-center w-10 h-10 rounded bg-primary/10">
            <Icon name="PieChart" size={24} color="var(--color-primary)" />
          </div>
          <span className="text-xl font-semibold font-heading text-foreground">
            StablecoinM2Tracker
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {navLinks?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`
                flex items-center gap-2 px-4 py-2 rounded transition-all duration-300
                ${isActivePath(item?.path)
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'text-foreground hover:bg-muted hover:text-foreground'
                }
              `}
            >
              <Icon 
                name={item?.icon} 
                size={18} 
                color={isActivePath(item?.path) ? 'var(--color-primary-foreground)' : 'currentColor'} 
              />
              <span className="text-sm font-medium">{item?.label}</span>
            </Link>
          ))}
        </nav>

        <button
          onClick={toggleMobileMenu}
          className="lg:hidden flex items-center justify-center w-10 h-10 rounded transition-colors duration-300 hover:bg-muted"
          aria-label="Toggle mobile menu"
        >
          <Icon 
            name={isMenuOpen ? 'X' : 'Menu'} 
            size={24} 
            color="var(--color-foreground)" 
          />
        </button>
      </div>
      {isMenuOpen && (
        <div className="lg:hidden bg-card border-t border-border">
          <nav className="flex flex-col py-2">
            {navLinks?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                onClick={() => setIsMenuOpen(false)}
                className={`
                  flex items-center gap-3 px-6 py-3 transition-colors duration-300
                  ${isActivePath(item?.path)
                    ? 'bg-primary/10 text-primary border-l-4 border-primary' :'text-foreground hover:bg-muted'
                  }
                `}
              >
                <Icon 
                  name={item?.icon} 
                  size={20} 
                  color={isActivePath(item?.path) ? 'var(--color-primary)' : 'currentColor'} 
                />
                <span className="text-base font-medium">{item?.label}</span>
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;